import { ApplicationConfig, APP_INITIALIZER } from '@angular/core';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { tenantInterceptor } from './core/interceptors/tenant.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { TenantBootstrapService } from './core/tenant/tenant-bootstrap.service';

export const appConfig: ApplicationConfig = {
  providers: [
    // paramsInheritanceStrategy: 'always' — o :tenantId vive na rota raiz; sem isto,
    // componentes filhos leem route.snapshot.paramMap.get('tenantId') como null e navegam
    // para rotas sem tenant, caindo no tenantGuard → /selecionar-tenant. Corrige os 14
    // componentes que resolvem o tenantId pelo paramMap de uma vez.
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({ paramsInheritanceStrategy: 'always' })
    ),
    provideHttpClient(
      withInterceptors([authInterceptor, tenantInterceptor, errorInterceptor])
    ),
    provideAnimations(),
    {
      provide: APP_INITIALIZER,
      useFactory: (bootstrap: TenantBootstrapService) => () => bootstrap.resolve(),
      deps: [TenantBootstrapService],
      multi: true,
    },
  ],
};
